import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AuthToken } from '../model/tokens/auth-token';
import { RefreshAuthToken } from '../model/tokens/refresh-auth-token';

@Injectable()
export class AuthTokenStorageService {
  private readonly TOKEN_KEY: string = 'auth-token';
  private readonly REFRESH_TOKEN_KEY: string = 'auth-refresh-token';

  constructor(private localStorageService: LocalStorageService) {}

  public setToken(authToken: AuthToken): void {
    this.localStorageService.save<AuthToken>(this.TOKEN_KEY, authToken);
  }

  public setRefreshToken(refreshToken: RefreshAuthToken): void {
    this.localStorageService.save<AuthToken>(this.REFRESH_TOKEN_KEY, refreshToken);
  }

  public logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }

  public getToken(): AuthToken | null {
    const token: AuthToken | void = this.localStorageService.get<AuthToken>(this.TOKEN_KEY);
    if (token) {
      return token;
    } else {
      return null;
    }
  }

  public getRefreshToken(): RefreshAuthToken | null {
    const token: RefreshAuthToken | void = this.localStorageService.get<RefreshAuthToken>(this.REFRESH_TOKEN_KEY);
    if (token) {
      return token;
    } else {
      return null;
    }
  }
}
